import { colorReducer } from "./slices/color";
import { configReducer } from "./slices/config";
import { insuranceReducer } from "./slices/insurance";
import { modalsReducer } from "./slices/modals";
import { prescriptionReducer } from "./slices/prescription";
import { tooltipReducer } from "./slices/tooltip";
import { workflowReducer } from "./slices/workflow";

const rootReducer = {
    config: configReducer,
    workflow: workflowReducer,
    color:colorReducer,
    tooltip: tooltipReducer,
    insurance:insuranceReducer,
    modals: modalsReducer,
    prescription: prescriptionReducer
    // another reducers (if we have)
};

export default rootReducer;